import { useNavigate, useSearchParams } from 'react-router-dom';
import { FiX, FiAlertCircle, FiRefreshCw, FiHome } from 'react-icons/fi';

export default function PaymentFail() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const code = searchParams.get('code');
  const message = searchParams.get('message');
  const orderId = searchParams.get('orderId');

  const getErrorMessage = (code) => {
    // 토스페이먼츠 에러 코드별 메시지
    const errorMessages = {
      'PAY_PROCESS_CANCELED': '사용자가 결제를 취소했습니다.',
      'PAY_PROCESS_ABORTED': '결제 진행 중 오류가 발생했습니다.',
      'REJECT_CARD_COMPANY': '카드사에서 승인이 거부되었습니다.',
      'EXCEED_MAX_CARD_INSTALLMENT_PLAN': '설정 가능한 최대 할부 개월 수를 초과했습니다.',
      'INVALID_CARD_EXPIRATION': '카드 유효기간이 만료되었습니다.',
      'NOT_ENOUGH_BALANCE': '잔액이 부족합니다.',
      'BELOW_MINIMUM_AMOUNT': '결제 금액이 최소 금액보다 작습니다.',
      'EXCEED_MAX_DAILY_AMOUNT': '일일 결제 한도를 초과했습니다.',
      'NOT_SUPPORTED_CARD': '지원하지 않는 카드입니다.',
      'INVALID_CARD_NUMBER': '잘못된 카드 번호입니다.',
      'CARD_LOST_OR_STOLEN': '분실 또는 도난 카드입니다.',
      'RESTRICTED_TRANSFER_ACCOUNT': '계좌는 입금이 제한됩니다.',
      'INVALID_ACCOUNT_INFO': '유효하지 않은 계좌 정보입니다.',
    };

    return errorMessages[code] || message || '결제에 실패했습니다.';
  };

  const getErrorAdvice = (code) => {
    const advice = {
      'REJECT_CARD_COMPANY': '다른 카드로 시도하거나 카드사에 문의해주세요.',
      'NOT_ENOUGH_BALANCE': '잔액을 확인하고 다시 시도해주세요.',
      'INVALID_CARD_EXPIRATION': '카드 유효기간을 확인하고 다른 카드로 시도해주세요.',
      'EXCEED_MAX_DAILY_AMOUNT': '일일 결제 한도를 초과했습니다. 내일 다시 시도하거나 다른 결제 수단을 이용해주세요.',
      'NOT_SUPPORTED_CARD': '다른 결제 수단을 선택해주세요.',
      'CARD_LOST_OR_STOLEN': '카드사에 문의하여 상태를 확인해주세요.',
    };

    return advice[code] || '문제가 지속되면 고객센터로 문의해주세요.';
  };

  return (
    <div className="payment-result-page">
      <div className="result-container error">
        {/* 에러 아이콘 */}
        <div className="result-icon error">
          <FiX size={64} />
        </div>

        {/* 제목 */}
        <h2>결제 실패</h2>
        <p className="error-message">{getErrorMessage(code)}</p>

        {/* 상세 정보 */}
        <div className="error-details-card">
          <div className="detail-item">
            <FiAlertCircle />
            <div>
              <span className="detail-label">실패 사유</span>
              <span className="detail-value">{getErrorAdvice(code)}</span>
            </div>
          </div>

          {orderId && (
            <div className="detail-item">
              <span className="detail-label">주문번호</span>
              <span className="detail-value small">{orderId}</span>
            </div>
          )}

          {code && (
            <div className="detail-item">
              <span className="detail-label">오류 코드</span>
              <span className="detail-value small">{code}</span>
            </div>
          )}
        </div>

        {/* 안내 메시지 */}
        <div className="info-box warning">
          <FiAlertCircle />
          <div>
            <h4>결제 실패 안내</h4>
            <ul>
              <li>결제가 완료되지 않았으며, 금액이 청구되지 않았습니다.</li>
              <li>카드 한도, 잔액, 유효기간 등을 확인해주세요.</li>
              <li>다른 결제 수단으로 다시 시도해보세요.</li>
            </ul>
          </div>
        </div>

        {/* 액션 버튼 */}
        <div className="actions">
          <button className="btn-secondary" onClick={() => navigate('/points')}>
            <FiHome />
            포인트 관리
          </button>
          <button className="btn-primary" onClick={() => navigate('/points/charge')}>
            <FiRefreshCw />
            다시 시도
          </button>
        </div>

        {/* 고객센터 안내 */}
        <div className="help-text">
          <p>문제가 지속되면 고객센터로 문의해주세요</p>
          <p className="contact-info">이메일: support@edustaff.com</p>
        </div>
      </div>
    </div>
  );
}
